/**
 * Custom JavaScript for Ruskovilla
 * Handles dynamic updates for Materials tab on product pages
 */

document.addEventListener('variant:change', function(event) {
  var variant = event.detail.variant;

  // Elements in Materials tab (both mobile accordion and desktop tabs)
  var variantNameElements = document.querySelectorAll('.materials-variant-name');
  var weightElements = document.querySelectorAll('.materials-weight');
  var weightContainers = document.querySelectorAll('.materials-weight-container');
  var skuElements = document.querySelectorAll('.materials-sku');
  var skuContainers = document.querySelectorAll('.materials-sku-container');

  // Update variant name
  variantNameElements.forEach(function(el) {
    el.textContent = variant ? variant.title : '';
  });

  // Update weight
  weightElements.forEach(function(el) {
    el.textContent = (variant && variant.weight > 0) ? variant.weight + ' g' : '';
  });

  weightContainers.forEach(function(el) {
    el.hidden = !variant || !variant.weight;
  });

  // Update SKU
  skuElements.forEach(function(el) {
    el.textContent = variant ? variant.sku : '';
  });

  skuContainers.forEach(function(el) {
    el.hidden = !variant || !variant.sku;
  });
});

/* SOLWE: collection pagination history - CUSTOMIZATIONS.md #3 */
/**
 * Impact loads collection and search pages with AJAX and then calls
 * history.replaceState, so moving from page 1 to page 2 overwrites the
 * history entry and the back button skips the collection entirely.
 * For pagination clicks only, push a copy of the current entry first, so
 * Impact's replaceState lands on the new entry. On back and forward, reload
 * the section for the URL the browser moved to.
 */
(function() {
  var loadedUrl = location.href;
  var sectionId = null;

  // Capture phase, so this runs before Impact's own facet:update listener
  document.addEventListener('facet:update', function(event) {
    var url = new URL(event.detail.url);
    sectionId = url.searchParams.get('section_id');
    url.searchParams.delete('section_id');

    var isPagination = event.target instanceof Element && event.target.closest('.pagination');
    if (isPagination && url.toString() !== location.href) {
      history.pushState({}, '', location.href);
    }

    loadedUrl = url.toString();
  }, true);

  window.addEventListener('popstate', function() {
    // A hash-only change is not a page change
    if (location.href.split('#')[0] === loadedUrl.split('#')[0]) {
      return;
    }

    var section = sectionId && document.getElementById('shopify-section-' + sectionId);
    if (!section) {
      location.reload();
      return;
    }

    var url = new URL(location.href);
    url.searchParams.set('section_id', sectionId);
    section.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url: url }
    }));
  });
})();
/* /SOLWE */
